import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { FunctionComponent } from 'react';
import styles from './BoardingHeaderTable.module.scss';
import HeaderTableColumn from './HeaderTableColumn';
import {
    checkInSorter,
    checkOutSorter,
    clientSorter,
    nightsSorter,
    petSorter,
    roomSorter,
    serviceSorter,
    statusSorter,
    totalSorter
} from './sorting';
import { Sorter } from '@spike/appointments-list-model';

interface BoardingHeaderTableProps {
    sorter: Sorter | null;
    onSort?: (sorter: Sorter) => void;
    allSelected?: boolean;
    onToggleSelectAll?: (checked: boolean) => void;
}

export const BoardingHeaderTable: FunctionComponent<BoardingHeaderTableProps> = props => {
    return (
        <TableHeader>
            {props.onToggleSelectAll && (
                <TableHeaderCell className={styles.checkboxCell}>
                    <Checkbox
                        checked={props.allSelected}
                        onChange={props.onToggleSelectAll}
                    />
                </TableHeaderCell>
            )}
            <HeaderTableColumn
                columnSorter={clientSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Client Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={petSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={serviceSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Service
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={roomSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Room
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={checkInSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Check In
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={checkOutSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Check Out
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={nightsSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
                className={styles.nights}
            >
                <FontAwesomeIcon icon={faMoon} />
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={totalSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Total
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={statusSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Status
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default BoardingHeaderTable;
